import React from 'react'
import CompaniesList from '../components-dev-admin/CompaniesList'

export default function Companies() {
  return (
    <CompaniesList />
  )
}
